import { DoubleColumnLayout, DoubleColumnLayoutColumn } from '@components'

import { useQueryParam, useQueryParams } from '@hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FileBrowser, FileDetailView, FolderDetailView } from './components'

export const FilesPage: React.FC = () => {
  const [t] = useTranslation()
  const [, setQueryParams] = useQueryParams()
  const [openItem] = useQueryParam('id', value => parseInt(value, 10))
  const [openType] = useQueryParam('idType')

  const onClose = () =>
    setQueryParams({
      id: undefined,
      idType: undefined
    })

  return (
    <DoubleColumnLayout
      header={t('files.mainHeader')}
      isRightVisible={Boolean(openItem)}
      onRightClose={() => onClose()}
    >
      <DoubleColumnLayoutColumn>
        <FileBrowser />
      </DoubleColumnLayoutColumn>

      <DoubleColumnLayoutColumn innerKey={openItem} isRight={true}>
        {openType === 'file' && (
          <FileDetailView key={openItem} fileId={openItem} onClose={() => onClose()} />
        )}

        {openType === 'folder' && (
          <FolderDetailView key={openItem} folderId={openItem} onClose={() => onClose()} />
        )}
      </DoubleColumnLayoutColumn>
    </DoubleColumnLayout>
  )
}
